import type { PhaseResource } from "@octopusdeploy/octopus-server-client";
import { union } from "lodash";

const envCount = (phase: PhaseResource): number => {
    return union(phase.AutomaticDeploymentTargets, phase.OptionalDeploymentTargets).length;
};

export default envCount;
